import React from 'react';
import { Form, Radio, Space, Typography, theme } from 'antd';
import { VideoCameraOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export type AppointmentFormat = 'in-person' | 'video';

/**
 * Select appointment format (in-person vs video).
 * Kept generic so multiple modules can reuse it.
 */
export const AppointmentFormatSelector: React.FC<{
  label?: string;
  requiredMessage?: string;
}> = ({ label, requiredMessage }) => {
  const { token } = theme.useToken();
  const { t } = useTranslation('manage');

  return (
    <Form.Item
      label={label ?? t('appointmentComponents.create.format.label')}
      name="appointmentFormat"
      rules={[{ required: true, message: requiredMessage ?? t('appointmentComponents.create.format.required') }]}
      initialValue="in-person"
    >
      <Radio.Group style={{ width: '100%' }}>
        <Space orientation="horizontal" size="middle" style={{ width: '100%' }}>
          <Radio value="in-person" style={{ padding: `${token.paddingXXS}px ${token.paddingXS}px` }}>
            <Space size="small">
              <UserOutlined style={{ fontSize: token.fontSize }} />
              <Text strong>{t('appointmentComponents.create.format.inPerson')}</Text>
            </Space>
          </Radio>
          <Radio value="video" style={{ padding: `${token.paddingXXS}px ${token.paddingXS}px` }}>
            <Space size="small">
              <VideoCameraOutlined style={{ fontSize: token.fontSize }} />
              <Text strong>{t('appointmentComponents.create.format.video')}</Text>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </Form.Item>
  );
};

